import React, { useState, useRef, useEffect } from "react";

function useHover() {
  const [value, setValue] = useState(false);
  const [count, setCount] = useState(-1)
  const [deviceType, setDeviceType] = useState("");
  const ref = useRef(null);
  const handleMouseOver = () => {
    setCount((count) => count + 1)
  };

  useEffect(() => {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
      hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
      const mQ = window.matchMedia && matchMedia("(pointer:coarse)");
      if (mQ && mQ.media === "(pointer:coarse)") {
        hasTouchScreen = !!mQ.matches;
      } else if ("orientation" in window) {
        hasTouchScreen = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        var UA = navigator.userAgent;
        hasTouchScreen =
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
      }
    }
    if (hasTouchScreen) {
      setDeviceType("click");
    } else {
      setDeviceType("mouseenter");
    }


  }, [window.innerHeight, window.innerWidth])

  useEffect(() => {
    if (count % 2 === 0) {
      setValue(true)
    } else {
      setValue(false)
    }
  }, [count])


  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        console.log(deviceType)
        node.addEventListener(deviceType, handleMouseOver);
        // node.addEventListener("mouseout", handleMouseOut);
        return () => {
          node.removeEventListener(deviceType, handleMouseOver);
          // node.removeEventListener("mouseout", handleMouseOut);
        };
      }
    },
    [ref.current, deviceType] // Recall only if ref changes
  );
  return [ref, value];
}

export default useHover